import * as React from 'react'
import { ITripHistoryObject } from '../../types'
import TripHistoryDetailSection from './TripHistoryDetailSection'
import * as moment from 'moment'

interface ITripHistoryTimingDetailsProps {
  trip: ITripHistoryObject
}

const TripHistoryTimingDetails = (props: ITripHistoryTimingDetailsProps) => {
  const trip = props.trip
  return (
    <TripHistoryDetailSection title='Timing'>
      <div className='flex h6 mb02 font-grey'>
        <div className='col-6'>Was requesting</div>
        <div className='col-6 right-align font-yellow'>
          {moment.utc(trip.wasRequestingTime * 1000).format('HH:mm:ss')}
        </div>
      </div>
      <div className='flex h6 mb02 font-grey'>
        <div className='col-6'>Was waiting for Pickup</div>
        <div className='col-6 right-align'>{moment.utc(trip.wasWaitingTime * 1000).format('HH:mm:ss')}</div>
      </div>
      <div className='flex h6 mb02 font-grey'>
        <div className='col-6'>Travel time</div>
        <div className='col-6 right-align'>{moment.utc(trip.travelTime * 1000).format('HH:mm:ss')}</div>
      </div>
      <div className='flex h6 mb02 font-grey'>
        <div className='col-6'>Travel distance</div>
        <div className='col-6 right-align'>{trip.travelDistance}</div>
      </div>
      <div className='flex h6 mb02 font-grey'>
        <div className='col-12'>
          Pickup dwell{' '}
          <span className='bold h6 font-black'>{moment.utc(trip.pickupDwell * 1000).format('HH:mm:ss')}</span> before
          enroute
        </div>
      </div>
      <div className='flex h6 mb02 font-grey'>
        <div className='col-12'>
          Dropoff dwell{' '}
          <span className='bold h6 font-black'>{moment.utc(trip.dropOffDwell * 1000).format('HH:mm:ss')}</span> before
          enroute
        </div>
      </div>
    </TripHistoryDetailSection>
  )
}

export default TripHistoryTimingDetails



// WEBPACK FOOTER //
// ./src/components/trips/TripHistoryTimingDetails.tsx